export type DataType =
    | 'SingleLine.Text'
    | 'SingleLine.TextArea'
    | 'SingleLine.Email'
    | 'SingleLine.Phone'
    | 'SingleLine.URL'
    | 'Multiple'
    | 'Whole.None'
    | 'Decimal'
    | 'DateAndTime.DateAndTime'
    | 'DateAndTime.DateOnly'
    | 'Currency'
    | 'OptionSet'
    | 'MultiSelectPicklist'
    | 'TwoOptions'
    | 'Lookup.Simple'
    | 'Lookup.Owner'
    | 'Lookup.Customer'
    | 'Lookup.Regarding'
    | 'Whole.Language'
    | 'Whole.Duration'
    | 'Whole.TimeZone'
    | 'File'
    | 'Image';

export class DataTypes {
    static get SingleLineText(): 'SingleLine.Text' {
        return 'SingleLine.Text';
    }

    static get SingleLineTextArea(): 'SingleLine.TextArea' {
        return 'SingleLine.TextArea';
    }

    static get SingleLineEmail(): 'SingleLine.Email' {
        return 'SingleLine.Email';
    }

    static get SingleLinePhone(): 'SingleLine.Phone' {
        return 'SingleLine.Phone';
    }

    static get SingleLineUrl(): 'SingleLine.URL' {
        return 'SingleLine.URL';
    }

    static get Multiple(): 'Multiple' {
        return 'Multiple';
    }

    static get WholeNone(): 'Whole.None' {
        return 'Whole.None';
    }

    static get Decimal(): 'Decimal' {
        return 'Decimal';
    }

    static get Fp(): 'Decimal' {
        return 'Decimal';
    }

    static get DateAndTimeDateAndTime(): 'DateAndTime.DateAndTime' {
        return 'DateAndTime.DateAndTime';
    }

    static get DateAndTimeDateOnly(): 'DateAndTime.DateOnly' {
        return 'DateAndTime.DateOnly';
    }

    static get Currency(): 'Currency' {
        return 'Currency';
    }

    static get OptionSet(): 'OptionSet' {
        return 'OptionSet';
    }

    static get MultiSelectOptionSet(): 'MultiSelectPicklist' {
        return 'MultiSelectPicklist';
    }

    static get TwoOptions(): 'TwoOptions' {
        return 'TwoOptions';
    }

    static get LookupSimple(): 'Lookup.Simple' {
        return 'Lookup.Simple';
    }

    static get LookupOwner(): 'Lookup.Owner' {
        return 'Lookup.Owner';
    }

    static get LookupCustomer(): 'Lookup.Customer' {
        return 'Lookup.Customer';
    }
    static get LookupRegarding(): 'Lookup.Regarding' {
        return 'Lookup.Regarding';
    }

    static get WholeLanguage(): 'Whole.Language' {
        return 'Whole.Language';
    }

    static get WholeDuration(): 'Whole.Duration' {
        return 'Whole.Duration';
    }

    static get WholeTimeZone(): 'Whole.TimeZone' {
        return 'Whole.TimeZone';
    }

    static get File(): 'File' {
        return 'File';
    }

    static get Image(): 'Image' {
        return 'Image';
    }

    // Method to return all properties in an array
    static GetAll() {
        return [
            this.SingleLineText,
            this.SingleLineTextArea,
            this.SingleLineEmail,
            this.SingleLinePhone,
            this.SingleLineUrl,
            this.Multiple,
            this.WholeNone,
            this.Decimal,
            this.Fp,
            this.DateAndTimeDateAndTime,
            this.DateAndTimeDateOnly,
            this.Currency,
            this.OptionSet,
            this.MultiSelectOptionSet,
            this.TwoOptions,
            this.LookupSimple,
            this.LookupOwner,
            this.LookupCustomer,
            this.WholeLanguage,
            this.WholeDuration,
            this.WholeTimeZone,
            this.File,
            this.Image
        ];
    }
}
